import { post } from '../axios'

export const authDeviceFinger = (params) => post('/intl/openapi/face-identity/v1/auth-4-device-finger', params)
export const upLoadToken = (params) => post('/intl/openapi/face-identity/v1/upload-token', params)
export const deviceInfo = (params) => post('/intl/openapi/face-identity/v1/get-device-info', params)
